module.exports = __webpack_public_path__ + "img/ic_error.44c573a0.svg";